var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnumBinning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.12 2v1.013h-.316c-.625 0-.937.333-.937 1V6.82c0 .35-.055.615-.164.794-.11.18-.287.308-.532.385.245.077.422.205.532.385.11.18.164.444.164.794v2.808c0 .667.312 1 .937 1h.316V14h-.557c-.633 0-1.11-.16-1.43-.48-.32-.321-.48-.794-.48-1.417v-2.95c0-.427-.19-.64-.57-.64L2 8.512V7.487h.083c.38 0 .57-.213.57-.64v-2.95c0-.623.16-1.096.48-1.416C3.453 2.16 3.93 2 4.563 2zm6.317 0c.633 0 1.11.16 1.43.48.32.321.48.794.48 1.417v2.95c0 .427.19.64.57.64H14v1.025h-.083c-.38 0-.57.214-.57.642v2.949c0 .623-.16 1.096-.48 1.416-.32.32-.797.481-1.43.481h-.557v-1.013h.316c.625 0 .937-.333.937-1V9.18c0-.35.055-.615.164-.794.11-.18.287-.308.532-.385-.245-.077-.422-.205-.532-.385-.11-.18-.164-.444-.164-.794V4.013c0-.667-.312-1-.937-1h-.316V2zM6.396 5.36L8.06 9.347l1.7-3.987h1.72l-2.63 6.12H7.141L4.52 5.36z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnumBinning);
export default __webpack_public_path__ + "static/media/enum-binning.2b2836b73a21328db0b2c8919335ce14.svg";
export { ForwardRef as ReactComponent };